import { UseQueryOptions } from "@tanstack/react-query";
import { useGeneralQueryWithoutToken } from "../useGeneralQuery";
import { AxiosResponse } from "axios";

export const useGenerateToken = (
	params: { phone?: string; pinfl?: string | number; smsCode?: string },
	options: UseQueryOptions<AxiosResponse<any>, Error> = {}
) => useGeneralQueryWithoutToken<{ token: string; refreshToken: string }>("/auth/generate-token", params, options);
